export const shouldRemoveBetterHelpProduct = (items) => {
  const calendarCount = items.filter((item) =>
    item?.node?.merchandise?.product?.handle?.includes('skylight-calendar')
  ).length

  return calendarCount === 0
}
